import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Chip } from '@reveni-io/reveni-ui'

import { getExportPriceCountriesInfo } from '../helpers'
import MissingInfoChip from '../MissingInfoChip/MissingInfoChip'
import { haveAllItemsSameExportPriceCountries } from './helpers'

const ExportPriceChip = ({ product }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <>
      {haveAllItemsSameExportPriceCountries(product) ? (
        <Chip
          label={getExportPriceCountriesInfo(product?.inventory_items?.[0].export_details, t)}
          backgroundColor={theme.colors.info.surface}
          color={theme.colors.info.onSurface}
        />
      ) : (
        <MissingInfoChip />
      )}
    </>
  )
}

export default ExportPriceChip
